module.exports = __webpack_public_path__ + "static/images/five.3j8m53V.svg";